module.exports = __webpack_public_path__ + "img/Mobile.d218278e.png";